import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { useState } from 'react';
import { useMaestroContext } from '../context/MaestroContext';
import maestroService from '../maestroService';
import { dispararAcaoSimulada } from '../utils/acaoSimulada';

const WizardEncerramentoCiclo: React.FC<{ aberto: boolean; onFechar: () => void }> = ({ aberto, onFechar }) => {
  const { cicloAtivo, pendenciasEncerramento, usuarios, recarregar } = useMaestroContext();
  const [excepcional, setExcepcional] = useState(false);
  const [justificativa, setJustificativa] = useState('');
  const [autorizadorId, setAutorizadorId] = useState<number>(0);
  const [aprovado, setAprovado] = useState(false);
  const [enviando, setEnviando] = useState(false);

  // MAESTRO-RN-39 — mesmo checklist que o backend valida no encerramento de verdade
  // (ValidarChecklistEncerramentoAsync), exposto via GET .../prontidao-encerramento e já carregado
  // no contexto a cada troca de ciclo. Nada aqui é reconstruído no cliente.
  const podeEncerrar = pendenciasEncerramento.length === 0;

  const confirmar = () => {
    setEnviando(true);
    const payload = podeEncerrar
      ? undefined
      : {
          justificativa: justificativa.trim(),
          autorizadorId,
          medidasCompensatorias: [{ descricao: justificativa.trim(), responsavelId: autorizadorId, prazo: new Date(Date.now() + 7 * 86400000).toISOString() }],
        };

    maestroService.encerrarCiclo(cicloAtivo.id, payload)
      .then(() => { recarregar(); onFechar(); })
      .catch((e: any) => dispararAcaoSimulada(e?.response?.data?.message ?? 'Não foi possível encerrar o ciclo.'))
      .finally(() => setEnviando(false));
  };

  return (
    <Dialog open={aberto} onClose={onFechar} maxWidth='sm' fullWidth PaperProps={{ className: 'mc-dialog' }}>
      <DialogTitle>Encerramento de Ciclo</DialogTitle>
      <DialogContent>
        <ul className='mc-wizard-checklist'>
          {pendenciasEncerramento.length === 0
            ? <li className='is-ok'><i className='bi bi-check-circle-fill' /><div><strong>Checklist de encerramento</strong><small>Sem pendências — ciclo pronto para encerrar.</small></div></li>
            : pendenciasEncerramento.map((pendencia, i) => (
              <li key={i} className='is-pendente'><i className='bi bi-x-circle-fill' /><div><strong>Pendência</strong><small>{pendencia}</small></div></li>
            ))}
        </ul>

        {!podeEncerrar && (
          <div className='mc-wizard-bloqueio'>
            <strong><i className='bi bi-exclamation-triangle' /> {pendenciasEncerramento.length} pendência(s) obrigatória(s) impedem o encerramento normal.</strong>
            <label className='mc-checkbox'>
              <input type='checkbox' checked={excepcional} onChange={e => setExcepcional(e.target.checked)} />
              Solicitar encerramento excepcional
            </label>
            {excepcional && (
              <div className='mc-wizard-excepcional'>
                <label>Justificativa<textarea rows={3} value={justificativa} onChange={e => setJustificativa(e.target.value)} placeholder='Motivo do encerramento excepcional...' /></label>
                <label>Usuário autorizador
                  <select value={autorizadorId} onChange={e => setAutorizadorId(Number(e.target.value))}>
                    <option value={0}>Selecione...</option>
                    {usuarios.filter(u => u.perfil === 'DIRETORIA' || u.perfil === 'CONTROLLER').map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}
                  </select>
                </label>
                <label className='mc-checkbox'><input type='checkbox' checked={aprovado} onChange={e => setAprovado(e.target.checked)} /> Aprovado pelo autorizador acima</label>
              </div>
            )}
          </div>
        )}

        <div className='mc-wizard-acoes'>
          <button type='button' className='mc-btn mc-btn--secondary' onClick={onFechar}>Cancelar</button>
          <button
            type='button'
            className='mc-btn mc-btn--primary'
            disabled={enviando || (!podeEncerrar && !(excepcional && justificativa.trim() && aprovado && autorizadorId > 0))}
            onClick={confirmar}
          >
            {enviando ? 'Enviando...' : podeEncerrar ? 'Encerrar ciclo' : 'Confirmar encerramento excepcional'}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WizardEncerramentoCiclo;
